import React from 'react';
import { cn } from '../../lib/utils';
interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}
export function Switch({
  checked,
  onCheckedChange,
  className,
  ...props
}: SwitchProps) {
  return <button type="button" role="switch" aria-checked={checked} onClick={() => onCheckedChange(!checked)} className={cn('relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2', className)} {...props as any} data-id="element-336">
      <span className="sr-only" data-id="element-337">Toggle</span>
      <span aria-hidden="true" className={cn('pointer-events-none absolute mx-auto h-4 w-8 rounded-full transition-colors duration-200 ease-in-out', checked ? 'bg-indigo-600' : 'bg-slate-200')} data-id="element-338" />
      <span aria-hidden="true" className={cn('pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-slate-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out', checked ? 'translate-x-4 border-indigo-600' : 'translate-x-0')} data-id="element-339" />
    </button>;
}